import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { func } from 'prop-types';
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router';
import { AppDivisionContext } from '../../../contexts/AppDivisionContext';
import { ProjectContext } from '../../../contexts/ProjectContext';
import ProjectPermissionContext from '../../../contexts/ProjectPermissionContext';
import { RolesContext } from '../../../contexts/RolesContext';
// utils
import api from '../../../utils/api';
import divisionApi from '../../../utils/api/division';
import projectApi from '../../../utils/api/project';
import { ActionButtons } from '../../Shared/ActionButtons';
import ConfirmationModal from '../../Shared/ConfirmationModal/ConfirmationModal';
import ArchiveProjectModal from './ArchiveProjectModal';
import Error from '../../Shared/ResourceIndex/Error';
import AppContext from '../../../contexts/AppContext';
import PrintInspectionsModal from './PrintInspectionsModal';
import PrintSiteMapModal from './PrintSiteMapsModal';
import { ProjectPrintProvider } from '../../../contexts/ProjectPrintContext';
import PrintSwmpModal from './PrintSwmpModal';
import XHR from '../../../utils/api/publicUrl';
import { env } from '../../../config';
import { Button, Modal } from "@sw-sw/lib-ui"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TenantFeatureContext from '../../../contexts/TenantContext';
import WeatherWidget from '../../Dashboard/WeatherWidget';
import { goToDirections } from '../../../utils/googlemaps';
import {removeOfflineProjects} from '../../../db/db';
import { offlineApi } from '../../../utils/api/offline';
import { useOffline } from '../../../contexts/OfflineContext';

function ProjectHeader({ onDelete, clientName }) {
  const [showDeleteModal, setDeleteModalVis] = useState(false);
  const [showPrintSwmpModal, setPrintSwmpModalVis] = useState(false);
  const [showPrintInspectionsModal, setShowPrintInspectionsModal] =
    useState(false);
  const [showPrintSiteMapModal, setShowPrintSiteMapModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [showRemoveOfflineDownloadModal, setShowRemoveOfflineDownloadModal] = useState(false);
  const [showQRmodal, setShowQRmodal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false)
  const [error, setError] = useState('');
  const [value, setValue] = React.useState('withImage');
  const [showForecast, setShowForecast] = useState(false);
  const isOffline = useOffline();

  const history = useHistory();

  const roleStore = useContext(RolesContext);
  const projectContext = useContext(ProjectContext);
  const featureContext = useContext(TenantFeatureContext)
  const { setReadOnly } = useContext(ProjectPermissionContext);
  const appDivisionContext = useContext(AppDivisionContext);
  const appContext = useContext(AppContext);
  const { project } = projectContext;

  const userCanDelete = roleStore.userHasPermission('delete', 'Project');
  const userCanArchive = roleStore.userHasPermission('update', 'Project',projectContext.isDownloaded());
  const userCanCreatePublic = roleStore.userHasPermission('all', 'QR Access');
  const userCanRemoveOfflineDownload = roleStore.userHasPermission('all', 'Remove Offline Project');
  const secondaryActions = useRef([]);
  // const userCanRemoveDuplicateLayer = roleStore.userHasPermission('all', 'Duplicate Map Layer');

  const userTenantId = appContext && appContext.state && appContext.state.user && appContext.state.user.tenantId
  const clientTenantId = projectContext && projectContext.project && projectContext.project.client && projectContext.project.client.tenant_id

  const handlePublic = () => {
    const projectId = projectContext.project.id

    localStorage.setItem("Qr Access", roleStore.userHasPermission('all', 'QR Access'))

    if (value === "withImage") {
      XHR.getPublicLink(projectId).then((res) => {
        window.open(`${window.location.origin}/public/divisions/${appDivisionContext.appDivisionId}/projects/${projectId}/inspections`);
      });
      localStorage.removeItem("No Image")
    } else {
      XHR.getPublicLink(projectId).then((res) => {
        window.open(`${window.location.origin}/public/divisions/${appDivisionContext.appDivisionId}/projects/${projectId}/inspections?image=false`);
        localStorage.setItem("No Image", true)
      });
    }
    setShowViewModal(false)
  }

  const removeDuplicateLayer = async () => {
    const response = await projectApi.removeDuplicateLayers(projectContext.project.id)

    alert(response)
  }

  useEffect(() => {
    if (!userTenantId || !clientTenantId) {
      return
    }
    else if (userTenantId !== clientTenantId) {
      history.push(appDivisionContext.getPath('/projects'));
    }
  }, [userTenantId, clientTenantId])


  /** set up secondary actions */
  useEffect(() => {
    const regex = /..*\/archive\/.*/;

    let isArchive = regex.test(window.location.pathname);

    if (roleStore.userHasPermission('all', 'Download')) {
      secondaryActions.current.push(
        {
          icon: 'print',
          label: 'Print Project Documents',
          onClick: () => setPrintSwmpModalVis(true),
        },
        {
          icon: 'print',
          label: 'Print Inspections',
          onClick: () => setShowPrintInspectionsModal(true),
        },
      );
    }

    if (featureContext.tenantHasFeature("Site Map - Editor Updates")) {
      secondaryActions.current.push({
        icon: 'print',
        label: 'Print Site Maps',
        onClick: () => setShowPrintSiteMapModal(true),
      })
    }

    if(featureContext.tenantHasFeature("Enable Route Planner")){
    secondaryActions.current.push({
      label:'Directions',
      icon: 'location-arrow',
      onClick: () => googleMapsGoToDirection()
    })
  }

    if (userCanDelete && !projectContext.isDownloaded()) {
      secondaryActions.current.push({
        icon: 'trash',
        label: 'Delete',
        onClick: () => setDeleteModalVis(true),
      });
    }

    if (userCanCreatePublic) {
      secondaryActions.current.push({
        label: 'Public View',
        icon: 'folder',
        onClick: () => setShowViewModal(true),
      });
    }

    if (userCanArchive && !isArchive && !projectContext.isDownloaded()) {
      secondaryActions.current.push({
        icon: 'archive',
        label: 'Archive',
        onClick: () => setShowArchiveModal(true),
      });
    }

    if (userCanArchive && isArchive && !projectContext.isDownloaded()) {
      secondaryActions.current.push({
        icon: 'undo',
        label: 'Restore',
        onClick: () => setShowRestoreModal(true),
      });
    }

    if(userCanRemoveOfflineDownload && projectContext.isDownloaded()) {
      secondaryActions.current.push({
        icon: 'trash',
        label: 'Remove Offline Download',
        onClick: () => setShowRemoveOfflineDownloadModal(true), 
      });
    }
    // if (userCanRemoveDuplicateLayer) { //Actual condition
    if (appContext.get("user").roleName === 'Admin') { //Tempororary condition until Matt's testing
      secondaryActions.current.push({
        icon: 'trash',
        label: 'Remove Duplicate Layers',
        onClick: () => removeDuplicateLayer(),
      });
    }

    if (window.innerWidth < 568) {
      secondaryActions.current.push({
        icon: 'cloud',
        label: 'Show Forecast',
        onClick: () => {
          setShowForecast(!showForecast);
          projectContext.fetchWeatherData();
        },
      });
    }

    return () => (secondaryActions.current.length = 0);
  }, [projectContext]);

  useEffect(() => {
    if (project.external_project) {
      secondaryActions.current = secondaryActions.current.filter(e => e.label !== "Print Inspections");
    }
  }, [project]);

  if (!project) {
    return <Error error='project is undefined' />;
  }

  function handleDelete() {
    return api
      .delete(`/api/projects/${project.id}`)
      .then((res) => {
        setDeleteModalVis(false);
        onDelete();
      })
      .catch((e) => {
        setError(
          e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'An error has occurred',
        );
      });
  }

  function handleArchive(notes) {
    return divisionApi.projects.archive
      .archive(appDivisionContext.appDivisionId, project.id, notes)
      .then((data) => {
        setShowArchiveModal(false);
        history.push(appDivisionContext.getPath('/projects'));
      })
      .catch((e) => {
        setError(
          e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'An error has occurred',
        );
      });
  }

  function handleRestore() {
    return divisionApi.projects.archive
      .restore(appDivisionContext.appDivisionId, project.id)
      .then((data) => {
        projectContext.setProject({
          ...projectContext.project,
          ...data,
        });
        history.push(
          `/divisions/${appDivisionContext.appDivisionId}/projects/${project.id}`,
        );
        setShowRestoreModal(false);
        setReadOnly(false);
      })
      .catch((e) => {
        setError(
          e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'An error has occurred',
        );
      });
  }


  function handleRemoveOfflineDownload() {
    
    return removeOfflineProjects(project.id)
     .then(()=>{
           offlineApi.delete(project.id);
        })
    .then(() => {
      setShowRemoveOfflineDownloadModal(false);

      projectContext.setProject({
        ...projectContext.project,
         offline_projects:[]
      })
      
    })
      .catch((e) => {
        setError(
          e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'An error has occurred',
        );
      });
  }

  function googleMapsGoToDirection() {
    const address = project.address
    const latitude = address.latitude
    const longitude = address.longitude

    goToDirections(latitude, longitude);
  }

  const countryOrState = () => {
    if (env.REACT_APP_REGION === "UK") {
      return `${project.address.countryObj ? project.address.countryObj.name : ""} `
    }

    return `${project.address.state ? project.address.state.abbreviation : ""} `
  }

  return (
    <Fragment>
      <section className='project-header pure-g'>
        <div className='project-info pure-u pure-u-1'>
          <div className='forecast-min-width'>
          {showForecast && !isOffline && <WeatherWidget isProject={true}/> }
          </div>
          <div className='project-title-seprator'>
            <div className='project-info-row'>
              <div className='project-info-column overflow-hidden'>
                <h2>
                  <FontAwesomeIcon icon='folder' className='header-icon' />
                  {project.name}
                </h2>
              </div>
              <h5>
                <FontAwesomeIcon icon='user' className='header-icon' />
                {clientName ? clientName : ''}
              </h5>
            </div>
            {!isOffline && (
            <div className='project-buttons pure-u pure-u-md-1-3 pure-u-sm-1-2 pure-u-1'>
              <div className='project-header-buttons'>
                <ActionButtons secondary={secondaryActions.current} />
                <div className='forecast-max-width'>
                  {showForecast ? (
                    <WeatherWidget isProject={true} />
                  ) : (
                    <ActionButtons
                      primary='Show Forecast'
                      onClick={() => {
                        setShowForecast(!showForecast);
                        projectContext.fetchWeatherData();
                      }}
                    />
                  )}
                </div>
              </div>
            </div>)}
          </div>
          {/* don't bother showing address if neither are set */}
          {project.address.street_1 ||
          project.address.city ||
          project.address.state ||
          project.address.countryObj ||
          project.address.zip ? (
            <h5>
              <FontAwesomeIcon icon='map-pin' className='header-icon' />
              {project.address.street_1}
              {project.address.street_1 ? ', ' : ''}
              {project.address.city}
              {project.address.city ? ', ' : ''}
              {countryOrState()}
              {project.address.zip}
            </h5>
          ) : null}
          <h5>
            {project.cgp_tracking_id && (
              <>
                <FontAwesomeIcon icon='file-alt' className='header-icon' />
                {project.cgp_tracking_id} &nbsp;
              </>
            )}
            {project.current_acreage && (
              <>
                <FontAwesomeIcon icon='map' className='header-icon' />
                {project.current_acreage} Acres
              </>
            )}
          </h5>
        </div>
      </section>

      {/* modals */}
      <ConfirmationModal
        show={showDeleteModal}
        handleConfirm={handleDelete}
        handleClose={() => setDeleteModalVis(false)}
        title='Are you sure you want to delete this project?'
        subTitle={`All documents and contacts associated with ${project.name} will be deleted.`}
        buttonText='Yes, I understand'
        errorMsg={error}
      />

      <ArchiveProjectModal
        show={showArchiveModal}
        handleArchive={handleArchive}
        handleClose={() => setShowArchiveModal(false)}
        projectName={project.name}
        errorMsg={error}
      />

      <ConfirmationModal
        show={showRestoreModal}
        handleConfirm={handleRestore}
        handleClose={() => setShowRestoreModal(false)}
        title='Are you sure you want to restore this project?'
        subTitle={`This will restore the ${project.name} project, making it available again in searches and lists.`}
        buttonText='Yes, I understand'
        errorMsg={error}
      />

      <ConfirmationModal
        show={showQRmodal}
        handleConfirm={handleRestore}
        handleClose={() => setShowQRmodal(false)}
        title='Are you sure you want to restore this project?'
        subTitle={`This will restore the ${project.name} project, making it available again in searches and lists.`}
        buttonText='Yes, I understand'
        errorMsg={error}
      />

      <ConfirmationModal
        show={showRemoveOfflineDownloadModal}
        handleConfirm={handleRemoveOfflineDownload}
        handleClose={() => setShowRemoveOfflineDownloadModal(false)}
        title='Are you sure you want to remove offline download?'
        subTitle={`This will remove the offline download for ${project.name} project`}
        buttonText='Yes, I understand'
        errorMsg={error}
      />

      <Modal
        show={showViewModal}
        title="View Public Page"
        handleClose={() => setShowViewModal(false)}
        hideButtons={true}
      >
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={(ele) => setValue((ele.target).value)}
          >
            <FormControlLabel value="withImage" control={<Radio />} label="Public View" />
            <FormControlLabel value="withOutImage" control={<Radio />} label="Public View Without Image" />
          </RadioGroup>

          <Button
            onClick={handlePublic}
          >
            Generate Public View
          </Button>
        </FormControl>
      </Modal>

      {showPrintSwmpModal && (
        <ProjectPrintProvider>
          <PrintSwmpModal onClose={() => setPrintSwmpModalVis(false)} />
        </ProjectPrintProvider>
      )}
      {showPrintInspectionsModal && (
        <ProjectPrintProvider>
          <PrintInspectionsModal
            onClose={() => setShowPrintInspectionsModal(false)}
          />
        </ProjectPrintProvider>
      )}
      {showPrintSiteMapModal && (
        <ProjectPrintProvider>
          <PrintSiteMapModal onClose={() => setShowPrintSiteMapModal(false)} />
        </ProjectPrintProvider>
      )}
    </Fragment>
  );
}

ProjectHeader.propTypes = {
  onDelete: func.isRequired,
};

export default ProjectHeader;
